type Member = {
  name: string;
  inst: string;
  img: string;
  text: string;
};

export const member: Member[] = [
  {
    name: "吉田雪乃",
    inst: "Vo. & Gt.",
    img: "/images/240921/Yukino.jpg",
    text: "2023年に学生時代から離れていた音楽に取り組むことを決意。7月、ワンマンライブを成功させ、わずか1か月で5曲のオリジナル曲を生み出す。最近SNS頑張ってます！笑 ぜひ覗いてみてください。",
  },

  {
    name: "松下福寿",
    inst: "Pf. & Key.",
    img: "/images/240921/Matsushita.jpg",
    text: "神奈川県横浜市出身。メーザーハウス、ピアノ科卒。卒業後本格的にプロ活動をスタート。ジャンルを問わず今井翼、IMALU、森山直太郎、大原櫻子など様々なアーティストと共演。また制作方面でも花澤香菜、雨宮天、すとぷり、サンリオなどの作品に録音やアレンジで参加。楽曲提供、編曲、アレンジメント等でも評価を得ている。現在はライブ、セッション、レコーディングや楽曲制作等、多岐にわたり精力的に活動している。",
  },
];
